/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tiny_Wild_Falcon_SwayInputs */

const fr_tiny_wild_falcon_sway = /** @type {(inputs: Tiny_Wild_Falcon_SwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la sauvegarde`)
};

/**

* @param {Tiny_Wild_Falcon_SwayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tiny_wild_falcon_sway = /** @type {((inputs?: Tiny_Wild_Falcon_SwayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tiny_Wild_Falcon_SwayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tiny_wild_falcon_sway(inputs)
});